function getPageRange(currentPage, totalPages) {
  const range = new Set();

  [1, 2, 3].forEach(p => { if (p <= totalPages) range.add(p); });

  for (let p = currentPage - 1; p <= currentPage + 1; p++) {
    if (p > 0 && p <= totalPages) range.add(p);
  }

  range.add(totalPages);

  const sorted = [...range].sort((a, b) => a - b);
  const result = [];
  for (let i = 0; i < sorted.length; i++) {
    if (i > 0 && sorted[i] - sorted[i - 1] > 1) {
      result.push('...');
    }
    result.push(sorted[i]);
  }
  return result;
}

function Pagination({ currentPage, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;

  return (
    <div className="pagination">
      <button
        className="pagination__btn"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        ‹
      </button>

      {getPageRange(currentPage, totalPages).map((page, i) =>
        page === '...'
          ? <span key={`dots-${i}`} className="pagination__dots">…</span>
          : <button
              key={page}
              className={`pagination__btn ${page === currentPage ? 'pagination__btn--active' : ''}`}
              onClick={() => onPageChange(page)}
            >
              {page}
            </button>
      )}

      <button
        className="pagination__btn"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        ›
      </button>
    </div>
  );
}

export default Pagination;
